import { useState } from 'react';
import InfoIcon from './InfoIcon.jsx';
import { bellSchedule } from '../data/bellSchedule.js';
import './BellSchedule.css';

function defaultScheduleId() {
  const day = new Date().getDay(); // 0=Sun 1=Mon 2=Tue 3=Wed 4=Thu 5=Fri 6=Sat
  return (day >= 2 && day <= 4) ? 'tues-wed-thurs' : 'monday-friday';
}

// School hours are 8:35 AM – 4:20 PM; hours 8–11 are AM, 12–4 are PM.
function ampm(t) {
  const h = parseInt(t.split(':')[0], 10);
  return (h >= 8 && h <= 11) ? `${t} AM` : `${t} PM`;
}

function ScheduleRows({ rows }) {
  return rows.map((row, i) => (
    <tr key={i} className={`bell-row${row.isLunch ? ' bell-row--lunch' : ''}`}>
      <td className="bell-period">{row.period}</td>
      <td className="bell-time">
        {ampm(row.start)} – {ampm(row.end)}
      </td>
      <td className="bell-tag-cell">
        {row.isLunch && <span className="bell-lunch-tag">lunch</span>}
      </td>
    </tr>
  ));
}

function GradeTable({ schedule, grade }) {
  const rows = [
    ...schedule.common,
    ...schedule.byGrade[grade],
    ...schedule.tail,
  ];
  return (
    <table className="bell-table bell-table--compact">
      <tbody>
        <ScheduleRows rows={rows} />
      </tbody>
    </table>
  );
}

export default function BellSchedule() {
  const [scheduleId, setScheduleId] = useState(defaultScheduleId);

  const schedule = bellSchedule.schedules.find(s => s.id === scheduleId);
  const grade6Rows = [
    ...schedule.common,
    ...schedule.byGrade['6'],
    ...schedule.tail,
  ];

  const verificationSource = {
    ...bellSchedule.source,
    note: bellSchedule.verificationNote,
    verificationNeeded: true,
  };

  return (
    <div className="bell-schedule">

      {/* Day-type toggle */}
      <div className="bell-toggle" role="group" aria-label="Select day type">
        {bellSchedule.schedules.map(s => (
          <button
            key={s.id}
            type="button"
            className={`bell-toggle-btn${scheduleId === s.id ? ' bell-toggle-btn--active' : ''}`}
            onClick={() => setScheduleId(s.id)}
          >
            {s.id === 'monday-friday' ? 'Mon / Fri' : 'Tue / Wed / Thu'}
          </button>
        ))}
        <InfoIcon source={verificationSource} />
      </div>

      {/* 6th-grade schedule table */}
      <table className="bell-table">
        <thead className="sr-only">
          <tr>
            <th>Period</th>
            <th>Time</th>
            <th>Note</th>
          </tr>
        </thead>
        <tbody>
          <ScheduleRows rows={grade6Rows} />
        </tbody>
      </table>

      <p className="bell-grade-note">
        Times shown for 6th grade. Other grades have lunch at a different period.
      </p>

      {/* 7th & 8th grade details — closed by default */}
      <details className="bell-other-grades">
        <summary className="bell-other-grades-summary">
          Show 7th & 8th grade times
        </summary>
        <div className="bell-other-grades-body">
          <p className="bell-other-grades-note">
            The difference is when lunch falls (periods 3–5). Everything else is identical.
          </p>
          <div className="bell-grade-pair">
            <div className="bell-grade-block">
              <h4 className="bell-grade-label">7th grade</h4>
              <GradeTable schedule={schedule} grade="7" />
            </div>
            <div className="bell-grade-block">
              <h4 className="bell-grade-label">8th grade</h4>
              <GradeTable schedule={schedule} grade="8" />
            </div>
          </div>
        </div>
      </details>
    </div>
  );
}
